import { render } from "./navList.vue?vue&type=template&id=d4b564ae&scoped=true"
import script from "./navList.vue?vue&type=script&lang=js"
export * from "./navList.vue?vue&type=script&lang=js"

import "./navList.vue?vue&type=style&index=0&id=d4b564ae&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b564ae"]])

export default __exports__